export const baseUrl = "https://dev2022.karactermania.com/api";
export const baseUrls = "https://dev2022.karactermania.com";
export const baseUrlCategory =
  "https://dev2022.karactermania.com/public/category";
export const baseUrlProduct =
  "https://dev2022.karactermania.com/public/product";
export const baseUrlColor =
  "https://dev2022.karactermania.com/public/attribute";
